const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_PLACES_API_KEY;
let loadingPromise = null;

export const loadGoogleMapsScript = () => {
  if (loadingPromise) {
    return loadingPromise;
  }

  if (window.google?.maps?.places) {
    return Promise.resolve(window.google.maps);
  }

  loadingPromise = new Promise((resolve, reject) => {
    try {
      const scriptId = 'google-maps-script';
      const existingScript = document.getElementById(scriptId);
      if (existingScript) {
        document.head.removeChild(existingScript);
      }

      // Créer un nom de callback unique
      const callbackName = `initGoogleMaps_${Date.now()}`;
      window[callbackName] = () => {
        if (window.google?.maps) {
          resolve(window.google.maps);
        } else {
          reject(new Error('Google Maps failed to initialize'));
        }
        delete window[callbackName];
        loadingPromise = null;
      };

      const script = document.createElement('script');
      script.id = scriptId;
      script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places&callback=${callbackName}`;
      script.async = true;

      script.addEventListener('error', () => {
        console.error('Failed to load Google Maps script');
        delete window[callbackName];
        loadingPromise = null;
        reject(new Error('Failed to load Google Maps script'));
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });

      document.head.appendChild(script);
    } catch (error) {
      console.error('Error setting up Google Maps:', error);
      loadingPromise = null;
      reject(error);
    }
  });

  return loadingPromise;
};
